import { Box, Heading, Text, Link } from '@chakra-ui/react';

export const Tournaments = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        Golden Gun Club hosts periodic registered tournaments throughout the year for Trap, Skeet, and Five-Stand shooting. These tournaments provide competitive shooters the opportunity to test their skills against other participants in a structured, sanctioned environment.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Tournament Types:</Heading>
      <Text mb={4} color="black">
        Our tournaments include registered shoots sanctioned by national shooting organizations. These events attract shooters from across the region and provide opportunities to earn classification scores and compete for awards.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">What to Expect:</Heading>
      <Text mb={4} color="black">
        Tournaments typically run over one or two days and include multiple events across different disciplines. Shooters can participate in individual events or compete in all-around competitions. Registration is required in advance, and specific event details including dates, times, and entry fees are published prior to each tournament.
      </Text>

      <Text mb={4} color="black">
        Both members and non-members are welcome to participate in our registered tournaments. These events are a great way to challenge yourself, meet other competitive shooters, and enjoy the sport at a higher level.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Upcoming Tournaments:</Heading>
      <Text mb={4} color="black">
        Check the tournament signup information page for details on upcoming registered shoots, including event schedules, registration deadlines, and entry requirements.
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Questions about tournaments?</Heading>
      <Text mb={4} color="black">
        For tournament information, contact <Link href="mailto:competitions@goldengunclub.us" color="blue.500">competitions@goldengunclub.us</Link>.
      </Text>
    </Box>
  );
};
